import logo from '../../assets/logo.png'
import css from './NotFound.module.css'

const NotFound = ()=> (  
  <div className={css.main}>
    <img className={css.imagen} src={logo} alt="logo" />
    <div className={css.content}>
      <h1 className={css.title}>Página no encontrada</h1>
      <p className={css.text}>
        Si tienes alguna duda, no dudes en ponerte en contacto con nosotros a través de nuestro correo electrónico{' '}
        <a className={css.link} href="mailto:hola@mundoestudiante.com">
          hola@mundoestudiante.com
        </a>
      </p>
    </div>
  </div>
)

export default NotFound